module.exports = __webpack_public_path__ + "img/pay_with_vipps_rect_210_EN.4c27cf6f.svg";